export default __webpack_public_path__ + "static/media/active-user.33e6615f.svg";